module.exports = __webpack_public_path__ + "img/pslogo.531c64e6.png";